import InfoView from '@/shared/publish/Homework/InfoView'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/publish/Homework/InfoView/$step/$page/')(
  {
    component: RouteComponent,
    loader: ({ params }) => {
      return {
        stepStr: params.step,
        pageStr: params.page
      }
    },
  },
)

function RouteComponent() {
  const { stepStr, pageStr } = Route.useLoaderData()
  return <InfoView
    stepStr={stepStr}
    pageStr={pageStr}
  />
}
